import type { TeamNode } from '@/types/entities'

/** Flattens the team tree into "Engineering / Platform" options, in tree order. */
export function flattenTeams(nodes: TeamNode[], prefix = ''): Array<{ id: string; label: string }> {
  return nodes.flatMap((node) => {
    const label = prefix ? `${prefix} / ${node.name}` : node.name
    return [{ id: node.id, label }, ...flattenTeams(node.children, label)]
  })
}
